export default __webpack_public_path__ + "static/Bitrate_Test_12_h264_hp_1280000-c68a6821196556293b7413642cd9dcc0.avif";